"use client";

import { createContext, type JSX, useContext } from "react";
import type { CartStoreType } from "@/features/cart/types/cart-store-type";

const CartStoreScopeContext = createContext<CartStoreType | null>(null);

type Props = {
  type: CartStoreType;
  children: JSX.Element;
};

export const CartStoreScopeProvider = ({ type, children }: Props) => {
  return (
    <CartStoreScopeContext.Provider value={type}>
      {children}
    </CartStoreScopeContext.Provider>
  );
};

export const useCartStoreScope = () => useContext(CartStoreScopeContext);
